import { Pipe, PipeTransform } from '@angular/core';
import { SessionRolePermissonType, SessionUserRole } from '../helpers/enums/enums';
import { LoggerService } from '../services/logger.service';
@Pipe({
    name: 'sessionRole'
})
export class SessionRolePipe implements PipeTransform {

    constructor(private readonly logger: LoggerService) { }

    transform(role: SessionUserRole, permissonType: SessionRolePermissonType) {
        try {
            switch (permissonType) {
                case SessionRolePermissonType.producer:
                    return role === SessionUserRole.producer;
                case SessionRolePermissonType.host:
                    return role === SessionUserRole.host;
                case SessionRolePermissonType.audience:
                    return role === SessionUserRole.audience;
                case SessionRolePermissonType.isProducerOrAudienceRole:
                    return role === SessionUserRole.audience || role === SessionUserRole.producer
                case SessionRolePermissonType.manageSessionEchoDisable:
                    return role === SessionUserRole.audience || role === SessionUserRole.producer
                case SessionRolePermissonType.manageSessionPlayAudio:
                    return role === SessionUserRole.host || role === SessionUserRole.guest || role === SessionUserRole.producer
                case SessionRolePermissonType.audienceViewBtn:
                    return role === SessionUserRole.host || role === SessionUserRole.producer
                case SessionRolePermissonType.endCallBtn:
                    return role === SessionUserRole.host || role === SessionUserRole.guest || role === SessionUserRole.audience || role === SessionUserRole.producer
                case SessionRolePermissonType.copyInvite:
                    return role === SessionUserRole.host || role === SessionUserRole.producer
                case SessionRolePermissonType.micBtn:
                    return role === SessionUserRole.host || role === SessionUserRole.guest || role === SessionUserRole.producer
                case SessionRolePermissonType.camBtn:
                    return role === SessionUserRole.host || role === SessionUserRole.guest
                case SessionRolePermissonType.chatBtn:
                    return role === SessionUserRole.host || role === SessionUserRole.guest || role === SessionUserRole.producer
                case SessionRolePermissonType.customizeBtn:
                    return role === SessionUserRole.host
                case SessionRolePermissonType.settingBtn:
                    return role === SessionUserRole.host || role === SessionUserRole.guest || role === SessionUserRole.producer
                case SessionRolePermissonType.raiseHandBtn:
                    return role === SessionUserRole.host || role === SessionUserRole.guest
                case SessionRolePermissonType.devicePermission:
                    return role === SessionUserRole.host || role === SessionUserRole.guest || role === SessionUserRole.producer
                case SessionRolePermissonType.localRecord:
                    return role === SessionUserRole.host || role === SessionUserRole.guest
                case SessionRolePermissonType.conferenceListener:
                    return role === SessionUserRole.audience
                case SessionRolePermissonType.participantWarning: {
                    return role === SessionUserRole.host || role === SessionUserRole.producer
                }
                case SessionRolePermissonType.uploadingStatus:
                    return role === SessionUserRole.host;

            }

        } catch (error) {
            this.logger.error('SessionRolePipe', error);
        }
    }

    isProducer(role: SessionUserRole) {
        return role === SessionUserRole.producer;
    }

    isAudience(role: SessionUserRole) {
        return role === SessionUserRole.audience;
    }


}  